import { z } from 'zod/v3';
import { errorMap, zName } from '../../common/utils';
import translations from './TokenSchema.translations.json';
import { i18nNsFactory } from '@atlas-frontend/i18n';

const { addTranslations, t } = i18nNsFactory('token-schema');
addTranslations(translations);

export const TokenSchema = z.object({
  id: z.number(),
  name: z.string(),
});

export const TokenCreatedSchema = TokenSchema.extend({
  token: z.string(),
});

export const TokenValidFormDataSchema = z.object({
  name: zName(errorMap(() => t('validation.name.required'))).min(1),
});
